import React from 'react';

export default class Footer extends React.Component{
  render(){
    return(
      <footer className='footer'>
        POKEMON_API - 2022 <br/>
        Develop With ❤️️ By Tarek Jamin
      </footer>
    )
  }
}
